import { actionProvider, installable } from 'shared/stores/core/decorators';

// Locks down the IA tools when certain events happen.
@installable
@actionProvider
export class ImageAnalysisLockdownService {
  remap = {
    USER_RIGHTS_CHANGED: 'EVALUATE_ANALYSIS_PERMISSIONS'
  };

  USCOPE_BIND_EVENTS ({dispatch}, uScope) {
    // This is useful for preventing ImageAnalysis from being drawn when in conferencing
    watch('uscope:enter-lockdown');
    watch('uscope:exit-lockdown');

    function watch (event) {
      uScope.events.on(event, () => { dispatch('EVALUATE__ANALYSIS_PERMISSIONS'); });
    }
  }

  async EVALUATE_ANALYSIS_PERMISSIONS ({dispatch, get, state}) {
    // If user doesn't have rights to run analysis or if uScope is in lockdown, lock IA. Otherwise, unlock it.
    const {uScope} = get('USCOPE');
    const rightsStore = state('USER_RIGHTS');
    const action = !rightsStore.currentRights.runAnalysis || uScope.isModeLockDown() ? 'IA_LOCK_ANALYSIS' : 'IA_UNLOCK_ANALYSIS';
    dispatch(action);
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/image-analysis/ImageAnalysisLockdownService.js